import React from "react";
import teamJson from "./teamJson.js";
import "./team.css";
import bgteamtop from "../images/bgteamtop.webp";
import ArrowRight from "./ArrowRights.js";
import useInViewAnimate from "../Hooks/useInViewAnimate";

function Team() {
  useInViewAnimate({
    selector: "[data-animate]",
    once: false,
    threshold: 0.15,
    rootMargin: "0px 0px -10% 0px",
  });

  const teamsWithDomain = teamJson.filter((team) => team.dominio);
  const teamsWithoutDomain = teamJson.filter((team) => !team.dominio);

  return (
    <>
      <section
        className="teamBgTop"
        style={{ backgroundImage: `url(${bgteamtop})` }}
        name="team"
      >
        <div className="content">
          <p className="subtitles" data-animate style={{ "--d": "0ms" }}>
            Meet the
          </p>

          <div className="titles" data-animate style={{ "--d": "80ms" }}>
            <h2>
              Team <sub>-</sub>
            </h2>
            <ArrowRight className="custom-arrow" />
            <span className="bajada">
              Somos una agencia digital radicada en Argentina. Nuestra tripulación
              está conformada por un equipo de profesionales que combinan diseño,
              tecnología y creatividad para resolver las necesidades de
              comunicación online de cada empresa.
            </span>
            <p>
              <a href="/aboutus" className="buttonIndexBlack">
                MORE ABOUT US
              </a>
            </p>
          </div>

          <ol className="teamList">
            {teamsWithDomain.map((team, idx) => {
              const img = `${process.env.PUBLIC_URL}/images/team/${team.alt}.webp`;

              return (
                <li
                  key={team.titulo}
                  data-animate
                  style={{ "--d": `${140 + idx * 70}ms` }}
                >
                  <figure>
                    <img width="100%" src={img} alt={team.titulo} loading="lazy"/>
                  </figure>
                  <div className="datos">
                    <p className="tituloTeam">{team.titulo}</p>
                    <p className="dominioTeam">{team.dominio}</p>
                    <p className="cargoTeam">{team.cargo}</p>
                  </div>
                </li>
              );
            })}
          </ol>

          {teamsWithoutDomain.length > 0 && (
            <ol className="fullteam">
              {teamsWithoutDomain.map((team, idx) => {
                const img = `${process.env.PUBLIC_URL}/images/team/${team.alt}.webp`;

                return (
                  <li
                    key={team.titulo}
                    data-animate
                    style={{ "--d": `${140 + (teamsWithDomain.length + idx) * 70}ms` }}
                  >
                    <figure>
                      <img width="100%" src={img} alt={team.titulo} loading="lazy"/>
                    </figure>
                    <div className="datos">
                      <p className="tituloTeam">{team.titulo}</p>
                      <p className="cargoTeam">{team.cargo}</p>
                    </div>
                  </li>
                );
              })}
            </ol>
          )}
        </div>
      </section>
    </>
  );
}

export default Team;